import React from 'react';
import { Stack } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

import { Neutrals } from '../../color-palette/colors';

export interface ButtonRowProps {
  children: React.ReactNode;
  align?: 'start' | 'end' | 'between';
  divider?: boolean;
  'aria-label'?: string;
  sx?: SxProps<Theme>;
}

const JUSTIFY: Record<NonNullable<ButtonRowProps['align']>, string> = {
  start: 'flex-start',
  end: 'flex-end',
  between: 'space-between',
};

const DIRECTION = { xs: 'column', sm: 'row' } as const;
const ALIGN_ITEMS = { xs: 'stretch', sm: 'center' } as const;

const dividerSx = { pt: 2, borderTop: `1px solid ${Neutrals[100]}` } as const;

export const ButtonRow: React.FC<ButtonRowProps> = ({ children, align = 'end', divider = false, 'aria-label': ariaLabel, sx }) => (
  <Stack
    role={ariaLabel ? 'group' : undefined}
    aria-label={ariaLabel}
    direction={DIRECTION}
    spacing={2}
    justifyContent={JUSTIFY[align]}
    alignItems={ALIGN_ITEMS}
    sx={[divider && dividerSx, ...(Array.isArray(sx) ? sx : [sx])]}
  >
    {children}
  </Stack>
);
